import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoEducationalBackgrounds from '@/components/formats/RirekishoParts/AutoEducationalBackgrounds.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import gradeYearOptions from '@/utils/format-edit/gradeYearOptions.json'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoEduHistoryCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null,
    hideHeading: { type: Boolean, default: false },
    compactTitle: { default: '' }
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, formatId?: string, basicData: BasicData, previewErrors: Record<string, string>, hideHeading: boolean, compactTitle: string };

const descriptionMaxLength = 80



// 書式によって学歴・職歴は 1 画面へ統合される（カード定義の `sections`）
const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  setEducationalBackgrounds,
  resetEducationalBackgrounds,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const educationalResetVisible = ref(false)

return { __sfc: true,descriptionMaxLength, props, isSection, formatData, activeHistoryItem, setEducationalBackgrounds, resetEducationalBackgrounds, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, activateHistoryItem, educationalResetVisible, HistoryItem, AutoEducationalBackgrounds, NewRirekishoResetDialog, gradeYearOptions }
}

})